import { BrowserTracing } from '@sentry/browser';
import {
  CaptureConsole,
  ExtraErrorData,
  HttpClient,
} from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { beforeSend } from '../functions/beforeSend';
import { getRelease } from '../functions/getRelease';
import { getTracesSampleRate } from '../functions/getTracesSampleRate';

export const sentryOptions: Sentry.BrowserOptions = {
  beforeSend,
  debug: false,
  dsn: 'https://20adc36c08104533969c4807d9169de5@o92107.ingest.sentry.io/1398689',
  environment: import.meta.env.VITE_APP_ENV,
  ignoreErrors: ['t.blacklistC'],
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      ),
    }),
    new CaptureConsole({ levels: ['error'] }),
    new ExtraErrorData(),
    new HttpClient(),
  ] as any,
  release: getRelease(),
  sendDefaultPii: true,
  tracesSampleRate: getTracesSampleRate(),
};
